// extracted by mini-css-extract-plugin
export default {"heading":"WarehouseDetail_heading__O8s9W","wrapper":"WarehouseDetail_wrapper__WtU6n"};